module.exports = __webpack_public_path__ + "img/custom.0b3f0ad9.png";